import { render, staticRenderFns } from "./HomeOrganic.vue?vue&type=template&id=1673d0a4"
import script from "./HomeOrganic.vue?vue&type=script&lang=js"
export * from "./HomeOrganic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports